var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialog',{attrs:{"showDialog":_vm.showDialog,"headline":"Release Validation Errors","close":_vm.close,"persistent":"","alvqa":_vm.alvqa},scopedSlots:_vm._u([{key:"dialogText",fn:function(){return [_c('v-container',[_c('v-row',[_c('v-col',[_vm._v("\n                    Validation Errors:\n                    ")])],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }